import { Component, OnInit, ViewChild } from '@angular/core';
import { MatAutocompleteSelectedEvent, MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent } from '@angular/material';
import { UserService } from '../services/user.service';
import * as moment from 'moment';
import { ClientOrderService } from '../clientorderreport/clientorderreport.service';
import { TableUtil } from '../admintrademaster/tableUtil';
import { AddClientTrade } from '../addclienttrade/addclienttrade.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { NotificationsService } from 'angular2-notifications';
const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-clienttradereport',
    templateUrl: './clienttradereport.component.html',
    styleUrls: ['./clienttradereport.component.css']
})

export class ClientTradeReportComponent implements OnInit {
    displayedColumns = [
        'action',
        'TradeTS',
        'Pair',
        'Side',
        'OrderType',
        'WalletType',
        'OrderSource',
        'Client',
        'UserEmail',
        'OrderId',
        'ClientOrderId',
        'TradeId',
        'TradePrice',
        'TradeQuantity',
        'TradeAmount',
        'TDS',
        'TDSCurrency',
        'CommentText',
        'OfflineClientName',
        'OfflineClientEmail',
        'IsActive',
    ];
    settlementDisplayedColumns = ['Currency', 'Amount'];
    public dataSource: any = new MatTableDataSource();
    public settlementDataSource: any = new MatTableDataSource();
    pageSize = 20;
    SpageSize = 20;
    SpageSizeOptions: number[] = [5, 10, 25, 50, 100];
    pageSizeOptions: number[] = [5, 10, 25, 50, 100];
    @ViewChild('paginator', null) paginator: MatPaginator;
    @ViewChild('paginator1', null) settlementPaginator: MatPaginator;
    @ViewChild('sort') sort: MatSort;
    @ViewChild('sort1') settlementTableSort: MatSort;
    fromDate;
    toDate;
    users;
    clients: any[] = [];
    clientListSearchCopy: any[] = [];
    selectedClientValue: boolean = true;
    isSettlementTabled: boolean = false;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    constructor(
        private clientService: ClientOrderService,
        private userService: UserService,
        public dialog: MatDialog,
        public notifSer: NotificationsService
    ) { }

    ngOnInit() {
        this.clientTradeReports();
        this.getClients();
        this.csrf();
        const fDate = Date.UTC(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), this.selectedDate.getDate());
        const tDate = Date.UTC(this.selectedDate1.getFullYear(), this.selectedDate1.getMonth(), this.selectedDate1.getDate()) + 86400000; // add one day's worth of milliseconds
        this.filter['fDate'] = fDate;
        this.filter['tDate'] = tDate;
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).valueOf();
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).valueOf();
        this.filter['tDate'] = this.toDate;
    }
    async applyFilterDate() {
        await this.clientTradeReports();
    }
    addClientTrade() {
        var new_element = {
            'UserEmail': '',
            'Pair': '',
            'TradeDate': '',
            'Side': '',
            'TradeQuantity': 0,
            'TradePrice': 0,
            'TradeAmount': 0,
            'OrderSource': '',
            'OrderType': '',
            'WalletType': '',
            'Client': '',
            'OfflineClientName': '',
            'OfflineClientEmail': '',
            'OrderId': '',
            'TradeId': '',
            'TradeTS': '',
            'ClientOrderId': '',
            'Fee': 0,
            'BaseCurrency': '',
            'QuoteCurrency': '',
            'FeeCurrency': '',
            'CommentText': '',
            'TDS' : 1,
            '_id': ''
        };
        const dialogRef = this.dialog.open(AddClientTrade, {
            width: '700px',
            data: new_element,
        }).afterClosed().subscribe(result => {
            if (result && result.success) {
                this.clientTradeReports();
            }
        });
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    filterDataForSettlement(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.settlementDataSource.filter = filterValue;
    }
    getClients() {
        this.userService.getClients().subscribe(clients => {
            this.users = clients
            clients = clients.map(function (item) {
                return { clientName: item.name };
            })
            this.clients = clients.map(list => list.clientName)
                .filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a > b ? 1 : -1);
            this.clientListSearchCopy = this.clients;
        })
    }
    filterWithClient(event: any) {
        let term = event;
        this.clients = this.clientListSearchCopy.filter(function (tag) {
            if (tag.toLowerCase().indexOf(term.toLowerCase()) >= 0 || tag.toLowerCase().indexOf(term.toLowerCase()) >= 0) {
                return tag;
            }
        });
    }
    onOptionSelected(event: MatAutocompleteSelectedEvent) {
        this.selectedClientValue = false;
        const selectedValue = event.option.value;
        const result = this.users.find(user => user.name === selectedValue);
        if (result)
            this.filter['UserId'] = result._id;
        else
            this.filter['UserId'] = '';

        this.clientTradeReports();
    }
    settlementReport() {
        this.isSettlementTabled = true;
        this.clientService.getSettlementReport(this.filter).subscribe(response => {
            this.settlementDataSource = new MatTableDataSource(response.data);
            this.settlementDataSource.paginator = this.settlementPaginator;
            this.settlementDataSource.sort = this.settlementTableSort;
        });
    }
    deleteManualTrade(TradeId,WalletType) {
        try {
            this.dialog.open(ConfirmationDialogComponent, {
                data: {
                    message: `Are you sure want to  delete manual trade?`,
                    buttonText: {
                        ok: 'Yes',
                        cancel: 'No'
                    }
                }
            }).afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                    const { notif } = defaults;
                    this.clientService.deleteClientTrade(TradeId,WalletType).subscribe(delRes => {
                        if (delRes) {
                            this.notifSer.success('Success', delRes.Message, notif)
                            this.clientTradeReports();
                        }
                        else this.notifSer.error('Error', delRes.Message, notif)
                    })
                }
            });
        } catch (error) {
            console.log(error);
        }
    }
    async clientTradeReports() {
        await this.userService.csrf().subscribe(async (success) => {
            this.filter["_csrf"] = success._csrf;
            //this.filter["UserId"] = UserId || '';
            await this.clientService.getTradeReportsWithFilter(this.filter).subscribe(async trades => {
                if (trades.data) {
                    let dateRes = await trades.data.map((trade => {
                        trade.TradeTS = moment(trade.TradeTS).format('MM/DD/YY hh:mm:ss A')
                        return trade;
                    }))
                    this.dataSource = new MatTableDataSource(dateRes);
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                }
            })
        })
    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }
    async exportArray(data = null) {
        if (this.dataSource.filteredData) {
            const ClientTradeArr = await this.dataSource.filteredData.map(x => ({
                TradeTS: x.TradeTS,
                Pair: x.Pair,
                Side: x.Side,
                OrderType: x.OrderType,
                OrderSource: x.OrderSource,
                Client: x.Client,
                UserEmail: x.UserEmail,
                OrderId: x.OrderId,
                ClientOrderId: x.ClientOrderId,
                TradePrice: x.TradePrice,
                TradeQuantity: x.TradeQuantity,
                TradeId: x.TradeId,
                TradeAmount: x.TradeAmount,
            }));
            TableUtil.exportArrayToExcel(ClientTradeArr, "ClientTradeReport");
        }

    }
    async exportArrayForSettlement() {
        if (this.settlementDataSource.filteredData) {
            const settlementArr = await this.settlementDataSource.filteredData.map(x => ({
                Currency: x.Currency,
                Amount: x.Amount,
            }));
            TableUtil.exportArrayToExcel(settlementArr, "settlementReport");
        }

    }


}

export interface ClientTradeData {
    TradeTS: string,
    Pair: string,
    Side: string,
    OrderType: string,
    OrderSource: string,
    Client: string,
    UserEmail: string,
    OrderId: string,
    ClientOrderId: string,
    TradePrice: number,
    TradeQuantity: number,
    TradeId: string,
    TradeAmount: number,

}
export interface settlementData {
    Currency: string,
    Amount: number
}



// WEBPACK FOOTER //
// ./src/app/clienttradereport/clienttradereport.component.ts